import { validate } from "cnpj";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Conta from "model/administracao/cadastro/Conta";
import Perfil from "model/administracao/cadastro/Perfil";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import Horario from "model/gestao/atividades/Horario";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import UsuarioService from "service/administracao/cadastro/UsuarioService";
import { cnpjMask, cpfMask } from "utils/mask";
import CPF from 'cpf-check';
import { AutoComplete } from "primereact/autocomplete";
import Pessoa from "model/administracao/cadastro/Pessoa";
import { pessoaCompleteMethod } from "utils/autocompleteUtils";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import PessoaCadastro from "pages/administracao/cadastro/pessoa/PessoaCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { AxiosError } from "axios";
import { MultiSelect } from "primereact/multiselect";

const usuarioService = new UsuarioService();
const contaService = new ContaService();

export default function UsuarioCadastro() {

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors } = useForm();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const navigate = useNavigate();

    const [usuario, setUsuario] = useState<Usuario>(new Usuario());
    const [perfis, setPerfis] = useState<Perfil[]>([]);
    const [setores, setSetores] = useState<Setor[]>([]);
    const [horarios, setHorarios] = useState<Horario[]>([]);
    const [conta, setConta] = useState<Conta>(new Conta());
    const [titulo, setTitulo] = useState<string>('Usuário');
    const [pessoas, setPessoas] = useState<Pessoa[]>([]);
    const [pessoasFiltradas, setPessoasFiltradas] = useState<Pessoa[]>([]);
    const [visibleCadastroPessoa, setVisibleCadastroPessoa] = useState<boolean>(false);
    const [idConta] = useState<number | null>(queryParameters.has('idConta') ? parseInt(queryParameters.get('idConta') || '0') : null);
    const editando = !window.location.pathname.includes('/cadastrar');

    const [emailUsuarioExiste, setEmailUsuarioExiste] = useState<string>("NAO_EXISTE");

    useEffect(() => {

        if (!usuario.horario || !usuario.horario.id) {
            setUsuario({ ...usuario, horario: new Horario(0, null, 'Selecione') });
        }

        const idConta = queryParameters.get('idConta');
        if (idConta) {

            contaService.consultar(parseInt(idConta)).then(contaParam => {

                setConta(contaParam);
                setTitulo(`Usuário da Conta ${contaParam.nome}`);

                usuarioService.perfis(parseInt(idConta)).then(perfisParam => {
                    setPerfis(perfisParam);
                });

                usuarioService.setores(parseInt(idConta)).then(setoresParam => {
                    setSetores([new Setor(0, null, 'Selecione'), ...setoresParam]);
                });

                usuarioService.horarios(parseInt(idConta)).then(horariosParam => {
                    setHorarios([new Horario(0, null, 'Selecione'), ...horariosParam]);
                });
                usuarioService.pessoas(parseInt(idConta)).then((data) => {
                    setPessoas(data);
                }).catch((error) => {
                    console.log(error);
                })
            });

        } else {

            usuarioService.perfis().then(perfisParam => {
                setPerfis(perfisParam);
            });

            usuarioService.setores().then(setoresParam => {
                setSetores([new Setor(0, null, 'Selecione'), ...setoresParam]);
            });

            usuarioService.horarios().then(horariosParam => {
                setHorarios([new Horario(0, null, 'Selecione'), ...horariosParam]);
            })
            usuarioService.pessoas().then((data) => {
                setPessoas(data);
            }).catch((error) => {
                console.log(error);
            })
        }

    }, []);

    function validar() {
        if (emailUsuarioExiste == "EXISTE_NESSA_CONTA") {
            msgAlerta('Atenção', 'Já existe um usuário com esse email nessa conta');
            return false;
        }

        if (emailUsuarioExiste == "NAO_EXISTE" && !usuario.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!usuario.email) {
            setError("emailField", { type: "manual", message: "Email é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (usuario.id <= 0) {
            if (emailUsuarioExiste == "NAO_EXISTE" && !usuario.senha) {
                setError("senha", { type: "manual", message: "Senha é obrigatória" }, { shouldFocus: true });
                return false;
            }
        }
        if (emailUsuarioExiste == "NAO_EXISTE" && usuario.condutor && !usuario.numeroDocumento) {
            setError("cpf", { type: "manual", message: "Documento é obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    const botoesExtra = <>
        <Button label="Adicionar Pessoa" style={{ marginLeft: 10 }} onClick={() => { setVisibleCadastroPessoa(true) }} />
    </>

    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    function buscarSeEmailExiste(email: string) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (!email || email.trim().length == 0) {
            return;
        }
        timeoutRef.current = setTimeout(() => {
            usuarioService.buscarSeEmailExiste(idConta, email).then((data) => {
                setEmailUsuarioExiste(data);
                if (data == "EXISTE_NESSA_CONTA") {
                    setError("email", { type: "manual", message: "Já existe um usuário com esse email nessa conta" }, { shouldFocus: true });
                }
            }).catch((error) => {
                console.log(error);
            })
        }, 1000)
    }



    return (

        <BaseCadastro model={usuario} botoesExtra={botoesExtra} service={usuarioService} novoCadastro getNewModel={() => new Usuario()} setModel={(value: Usuario) => {

            let horarioLocal = value.horario;
            if (!value.horario) {
                horarioLocal = new Horario(0, null, 'Selecione');
            }

            setUsuario({ ...value, horario: horarioLocal });

        }} validar={() => validar()} urlService="/usuario" pathCadastro="/usuario" tituloPagina={'Usuário'}>

            <Dialog header="Cadastro de Pessoa" visible={visibleCadastroPessoa} style={{ width: '75vw' }} onHide={() => setVisibleCadastroPessoa(false)}>
                <PessoaCadastro onSave={(pessoa: Pessoa) => {
                    setVisibleCadastroPessoa(false);
                    usuarioService.pessoas().then((data) => {
                        setPessoas(data);
                    }).catch((error) => {
                        msgErro('Erro', 'Erro ao encontrar pessoas');
                    });
                }} isModal />
            </Dialog>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}
            <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>

                <div style={{ display: "flex", marginTop: 4 }}>
                    <Checkbox
                        checked={usuario.ativo}
                        onChange={(e) => { setUsuario({ ...usuario, ativo: e.checked as boolean }) }}
                        style={{ marginRight: 5 }}
                    />
                    <label>Ativo</label>
                </div>

                <div style={{ display: "flex", marginTop: 4 }}>
                    <Checkbox
                        checked={usuario.auditor}
                        onChange={(e) => { setUsuario({ ...usuario, auditor: e.checked as boolean }) }}
                        style={{ marginRight: 5 }}
                    />
                    <label>Auditor</label>
                </div>

                <div style={{ display: "flex", marginTop: 4 }}>
                    <Checkbox
                        checked={usuario.tecnico}
                        onChange={(e) => { setUsuario({ ...usuario, tecnico: e.checked as boolean }) }}
                        style={{ marginRight: 5 }}
                    />
                    <label>Técnico</label>
                </div>

                <div style={{ display: "flex", marginTop: 4 }}>
                    <Checkbox
                        checked={usuario.notificacaoHorario}
                        onChange={(e) => { setUsuario({ ...usuario, notificacaoHorario: e.checked as boolean }) }}
                        style={{ marginRight: 5 }}
                    />
                    <label>Enviar notificação em caso de digergências de horários nas atividades</label>
                </div>

                <div style={{ display: "flex", marginTop: 4 }}>
                    <Checkbox
                        checked={usuario.condutor}
                        onChange={(e) => { setUsuario({ ...usuario, condutor: e.checked as boolean }) }}
                        style={{ marginRight: 5 }}
                    />
                    <label>Condutor</label>
                </div>

                {emailUsuarioExiste == "NAO_EXISTE" ? <div className="row">
                    <Label className="col col-sm-12" obrigatorio>Nome</Label>
                    <div className="col-sm-12">
                        <InputText required value={usuario.nome} style={{ width: '100%' }}
                            className={errors.nome ? "p-invalid" : ""}
                            {...register("nome", {
                                onChange: (e) => {
                                    clearErrors("nome");
                                    setUsuario({ ...usuario, nome: e.target.value })
                                }
                            })}
                        />
                    </div>
                    {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
                </div> : null}

                <div className="row">
                    <Label className="col col-sm-12" obrigatorio>E-mail</Label>
                    <div className="col-sm-12">
                        <div style={{ display: 'flex', alignItems: 'center', columnGap: 10 }} >
                            {emailUsuarioExiste == "EXISTE_OUTRA_CONTA" ? <>
                                <Tooltip target=".custom-target-icon" position="top" />
                                <Badge value="!" className="custom-target-icon" severity="info" data-pr-tooltip="Esse email já está cadastrado em outra conta, não é necessário informar nome e senha."></Badge>
                            </> : null}

                            {/*campo fake para o chrome não dar autocomplete*/}
                            <input type="email" name="email" autoComplete="email" style={{ display: 'none' }} />

                            <InputText required value={usuario.email} autoComplete="new-email" autoCapitalize="none" disabled={usuario.id > 0} readOnly={usuario.id > 0} style={{ width: '100%' }}
                                className={errors.emailField ? "p-invalid" : ""}
                                {...register("emailField", {
                                    onChange: (e) => {
                                        clearErrors("emailField");
                                        setUsuario({ ...usuario, email: e.target.value })
                                        if (!editando) {
                                            buscarSeEmailExiste(e.target.value);
                                        }
                                    }
                                })}
                            />
                        </div>
                    </div>
                    {errors.emailField && errors.emailField.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.emailField?.message as string}</span> : null}
                </div>

                {emailUsuarioExiste != "NAO_EXISTE" || usuario.id > 0 ? null : <>
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Senha</Label>
                        <div className="col-sm-12">
                            <InputText
                                required type="password"
                                autoComplete="new-password"
                                className={errors.senha ? "p-invalid" : ""}
                                value={usuario.senha}
                                style={{ width: '100%' }}
                                {...register("senha", {
                                    onChange: (e) => {
                                        clearErrors("senha");
                                        setUsuario({ ...usuario, senha: e.target.value })
                                    }
                                })}
                            />
                        </div>
                        {errors.senha && errors.senha.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.senha?.message as string}</span> : null}
                    </div>
                </>}

                {emailUsuarioExiste == "NAO_EXISTE" ? <div className="row">
                    <Label className="col col-sm-12" obrigatorio={usuario.condutor ? true : false}>Tipo de Documento</Label>
                    <div className="col-sm-12">
                        <Dropdown value={usuario.tipoDocumento} options={usuarioService.getTiposDocumento()} optionLabel="label" optionValue="value"
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                clearErrors("tipoDocumento")
                                setUsuario({ ...usuario, tipoDocumento: e.target.value, numeroDocumento: "" })
                            }}
                        />

                    </div>
                    {errors.tipoDocumento && errors.tipoDocumento.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoDocumento?.message as string}</span> : null}
                </div> : null}

                {emailUsuarioExiste == "NAO_EXISTE" && usuario.tipoDocumento === 'CPF' ?
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio={usuario.condutor ? true : false}>CPF</Label>
                        <div className="col-sm-12">
                            <InputText className={errors.cpf ? "p-invalid" : ""} value={usuario.numeroDocumento}
                                style={usuario.numeroDocumento ?
                                    cpfMask(usuario.numeroDocumento).length == 14 ?
                                        CPF.validate(usuario.numeroDocumento) || usuario.numeroDocumento == '000.000.000-00' ?
                                            { color: "#22211e", width: '30%' } :
                                            { color: "red", width: '30%' } :
                                        { width: '30%' } :
                                    { color: "red", width: '30%' }
                                }
                                {...register("cpf", {
                                    onChange: (e) => {
                                        clearErrors("cpf")
                                        setUsuario({ ...usuario, numeroDocumento: cpfMask(e.target.value) })
                                    }
                                })}
                            />

                        </div>
                        {errors.cpf && errors.cpf.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.cpf?.message as string}</span> : null}
                    </div>
                    : emailUsuarioExiste == "NAO_EXISTE" && usuario.tipoDocumento === 'CNPJ' ?
                        <div className="row">
                            <Label className="col col-sm-12">CNPJ</Label>
                            <div className="col-sm-12">
                                <InputText className={errors.cnpj ? "p-invalid" : ""} value={usuario.numeroDocumento}
                                    style={usuario.numeroDocumento ?
                                        cnpjMask(usuario.numeroDocumento).length == 18 ?
                                            validate(cnpjMask(usuario.numeroDocumento)) || usuario.numeroDocumento == '00.000.000/0000-00' ?
                                                { color: "#22211e", width: '30%' } :
                                                { color: "red", width: '30%' } :
                                            { width: '30%' } :
                                        { width: '30%' }}
                                    {...register("cnpj", {
                                        onChange: (e) => {
                                            clearErrors("cnpj")
                                            setUsuario({ ...usuario, numeroDocumento: cnpjMask(e.target.value) });
                                        }
                                    })}

                                />

                            </div>
                            {errors.cnpj && errors.cnpj.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.cnpj?.message as string}</span> : null}
                        </div>
                        : null}
            </form>



            <div className="row">
                <div className="col-sm-12">

                    <DataTable
                        header='Perfis'
                        value={perfis}
                        selectionMode='checkbox'
                        selection={usuario.perfis}
                        onSelectionChange={(e: any) => setUsuario({ ...usuario, perfis: e.value as Perfil[] })}
                        dataKey="id"
                        tableStyle={{ minWidth: '50rem' }}
                        emptyMessage="Nenhum registro encontrado"
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="nome" header="Nome"></Column>
                    </DataTable>
                </div>
            </div>

            <div className="row"  >
                <Label className="col col-sm-12">Setores</Label>
                <MultiSelect
                    className="col col-sm-12"
                    options={setores}
                    optionLabel="nome"
                    value={usuario.usuarioSetores.map(us => us.setor)}
                    style={{ width: '100%' }}
                    onChange={(e) => {
                        setUsuario({
                            ...usuario, usuarioSetores: e.value.map((setor: Setor) => {
                                return { id: 0, setor: setor }
                            })
                        })
                    }}
                />
            </div>

            <div className="row">
                <Label className="col col-sm-12">Cliente</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={usuario.pessoa}
                        placeholder="Selecione o Cliente"
                        style={{ width: '50%' }}
                        field="nome"
                        itemTemplate={(item: Pessoa) => item.numeroDocumento + " - " + item.nome}
                        suggestions={pessoasFiltradas}
                        completeMethod={(e) => {
                            let filtered: Pessoa[] = pessoaCompleteMethod(pessoas, e.query);
                            setPessoasFiltradas(filtered);
                        }}
                        onChange={(e) => {
                            let usuarioLocal = JSON.parse(JSON.stringify(usuario));

                            if (!e.target.value) {
                                usuarioLocal.pessoa = null;
                            } else if (typeof e.target.value == "string") {
                                let pessoa = new Pessoa();
                                pessoa.nome = e.target.value;
                                usuarioLocal.pessoa = pessoa;
                            } else {
                                usuarioLocal.pessoa = e.target.value;
                            }

                            setUsuario(usuarioLocal);
                        }}
                    />
                </div>
            </div>

            <div className="row"  >
                <Label className="col col-sm-12">Horário padrão</Label>
                <Dropdown
                    className="col col-sm-12"
                    options={horarios}
                    optionLabel="nome"
                    value={usuario.horario}
                    style={{ width: '100%' }}
                    onChange={(e) => setUsuario({ ...usuario, horario: e.value as Horario })}
                />
            </div>

            <div className="row"  >
                <Label className="col col-sm-12">Email drive</Label>
                <InputText
                    className="col col-sm-12"
                    value={usuario.emailDrive}
                    style={{ width: '100%' }}
                    onChange={(e) => setUsuario({ ...usuario, emailDrive: e.target.value })}
                />
            </div>

        </BaseCadastro>
    )
}
